import React from "react";
import { Slide } from "react-reveal";

const Carousel1 = () => {
  const carouselImage = [
    "images/companyLogo1.gif",
    "images/Carousel_2.jpg",
    "images/Carousel_3.jpg",
  ];

  return (
    <div id="Home" style={{ top: 0 }}>
      <div
        id="carouselExampleIndicators"
        class="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active" data-bs-interval="8000">
            <img
              class="d-block w-100"
              src={"images/companyLogo2.gif"}
              alt="First slide"
            />
          </div>
          <div class="carousel-item" data-bs-interval="5000">
            <img
              class="d-block w-100"
              src={"images/Carousel_2.jpg"}
              alt="First slide"
            />
          </div>
          <div class="carousel-item" data-bs-interval="5000">
            <img
              class="d-block w-100"
              src={"images//Carousel_3.jpg"}
              alt="First slide"
            />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Carousel1;
